var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "screen-container", class: { allScreen: _vm.isAllScreen } },
    [
      _c(
        "div",
        { staticClass: "search" },
        [
          _c(
            "el-form",
            { attrs: { inline: "" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("ocean-bi::sale-area::分析维度") } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "110px", "margin-right": "8px" },
                      on: { change: _vm.changeDimension },
                      model: {
                        value: _vm.dimensionType,
                        callback: function ($$v) {
                          _vm.dimensionType = $$v
                        },
                        expression: "dimensionType",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("ocean-bi::sale-area::商品品类"),
                          value: "category",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("ocean-bi::sale-area::商品SPU"),
                          value: "spu",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-select",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.dimensionType === "category",
                          expression: "dimensionType === 'category'",
                        },
                      ],
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        placeholder: _vm.$t(
                          "ocean-bi::sale-area::请选择商品品类"
                        ),
                      },
                      model: {
                        value: _vm.params.category,
                        callback: function ($$v) {
                          _vm.$set(_vm.params, "category", $$v)
                        },
                        expression: "params.category",
                      },
                    },
                    _vm._l(_vm.dimensionOptions.categoryList, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                  _c(
                    "el-select",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.dimensionType === "spu",
                          expression: "dimensionType === 'spu'",
                        },
                      ],
                      attrs: {
                        multiple: "",
                        filterable: "",
                        remote: "",
                        "remote-method": _vm.getSpuList,
                        placeholder: _vm.$t(
                          "ocean-bi::sale-area::请搜索商品SPU"
                        ),
                      },
                      model: {
                        value: _vm.params.spuId,
                        callback: function ($$v) {
                          _vm.$set(_vm.params, "spuId", $$v)
                        },
                        expression: "params.spuId",
                      },
                    },
                    _vm._l(_vm.dimensionOptions.spuIdList, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("ocean-bi::sale-area::价格带") } },
                [
                  _c(
                    "div",
                    [
                      _c("el-input", {
                        staticStyle: { width: "90px" },
                        attrs: {
                          placeholder: _vm.$t("ocean-bi::sale-area::最低价格"),
                        },
                        model: {
                          value: _vm.params.minPrice,
                          callback: function ($$v) {
                            _vm.$set(_vm.params, "minPrice", $$v)
                          },
                          expression: "params.minPrice",
                        },
                      }),
                      _c("span", [_vm._v("-")]),
                      _c("el-input", {
                        staticStyle: { width: "90px" },
                        attrs: {
                          placeholder: _vm.$t("ocean-bi::sale-area::最高价格"),
                        },
                        model: {
                          value: _vm.params.maxPrice,
                          callback: function ($$v) {
                            _vm.$set(_vm.params, "maxPrice", $$v)
                          },
                          expression: "params.maxPrice",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("ocean-bi::sale-area::排序") } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "150px" },
                      model: {
                        value: _vm.params.sortWord,
                        callback: function ($$v) {
                          _vm.$set(_vm.params, "sortWord", $$v)
                        },
                        expression: "params.sortWord",
                      },
                    },
                    _vm._l(_vm.sortOption, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("ocean-bi::sale-area::统计时间") } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "260px" },
                    attrs: {
                      appendToBody: true,
                      clearable: false,
                      type: "daterange",
                      "unlink-panels": "",
                      "range-separator": _vm.$t("system::time::text::include"),
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "picker-options": _vm.pickerOptions,
                    },
                    on: { change: _vm.handlerDateChange },
                    model: {
                      value: _vm.date,
                      callback: function ($$v) {
                        _vm.date = $$v
                      },
                      expression: "date",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.getAllData },
                    },
                    [_vm._v(_vm._s(_vm.$t("system::common::btn::search")))]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: {
                        "background-color": "#666666",
                        "border-color": "#666666",
                      },
                      attrs: { type: "info" },
                      on: { click: _vm.reset },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("system::common::btn::reset")) + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { display: "flex" } },
        [
          _c("div", { staticClass: "sale-range-city" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      "ocean-bi::sale-area::" + _vm.translateKey[_vm.sortWord]
                    ) + _vm.$t("ocean-bi::sale-area::前十城市概况")
                  ) +
                  "-" +
                  _vm._s(
                    _vm.params.countryName ||
                      _vm.$t("ocean-bi::sale-area::全球")
                  ) +
                  " "
              ),
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading.range,
                    expression: "loading.range",
                  },
                ],
                staticClass: "cityRange",
                attrs: {
                  "element-loading-background": "rgba(34, 34, 36, 0.3)",
                },
              },
              [
                _vm.cityRangeList.length
                  ? _vm._l(_vm.cityRangeList, function (item) {
                      return _c(
                        "div",
                        { key: item.city, staticClass: "bar-item" },
                        [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content: item.city,
                                placement: "top-start",
                              },
                            },
                            [
                              _c("div", { staticClass: "bar-name" }, [
                                _vm._v(_vm._s(item.city)),
                              ]),
                            ]
                          ),
                          _c(
                            "el-popover",
                            {
                              staticClass: "progress",
                              attrs: {
                                placement: "right-start",
                                width: "200",
                                trigger: "hover",
                                "append-to-body": false,
                                "popper-class": "bar-popover",
                              },
                            },
                            [
                              _c("div", { staticClass: "bar-popover-title" }, [
                                _vm._v(_vm._s(item.city)),
                              ]),
                              _c(
                                "div",
                                { staticClass: "bar-popover-content" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("ocean-bi::sale-area::销量")
                                      )
                                    ),
                                  ]),
                                  _c("span", [_vm._v(_vm._s(item.sale))]),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "bar-popover-content" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("ocean-bi::sale-area::成交额")
                                      )
                                    ),
                                  ]),
                                  _c("span", [
                                    _vm._v(
                                      "$" +
                                        _vm._s(
                                          Number(item.grandTotalUsd).toFixed(2)
                                        )
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "bar-popover-content" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("ocean-bi::sale-area::退款量")
                                      )
                                    ),
                                  ]),
                                  _c("span", [_vm._v(_vm._s(item.refundSale))]),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "bar-popover-content" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("ocean-bi::sale-area::退款金额")
                                      )
                                    ),
                                  ]),
                                  _c("span", [
                                    _vm._v(
                                      "$" +
                                        _vm._s(
                                          Number(item.refundUsd).toFixed(2)
                                        )
                                    ),
                                  ]),
                                ]
                              ),
                              _c("el-progress", {
                                attrs: {
                                  slot: "reference",
                                  "text-inside": true,
                                  "stroke-width": 18,
                                  percentage: item.per,
                                  format: function (val) {
                                    return _vm.translateKey[
                                      _vm.sortWord
                                    ].includes("Usd")
                                      ? Number(
                                          item[_vm.translateKey[_vm.sortWord]]
                                        ).toFixed(2)
                                      : item[_vm.translateKey[_vm.sortWord]]
                                  },
                                },
                                slot: "reference",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    })
                  : _c("ZDefaultData", {
                      staticStyle: { background: "none" },
                      attrs: {
                        custom: {
                          height: "360px",
                          img: require("@/assets/images/emptyDefault/empty_dark.png"),
                        },
                      },
                    }),
              ],
              2
            ),
          ]),
          _c("Map", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading.map,
                expression: "loading.map",
              },
            ],
            ref: "mapContainer",
            staticClass: "map",
            attrs: {
              config: _vm.mapConfig,
              "element-loading-background": "rgba(45, 45, 48, 0.3)",
            },
            on: { changeZone: _vm.changeZone },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "category-sale" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-bottom": "16px",
                      "font-weight": "bold",
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("ocean-bi::sale-area::品类销售概况")) +
                        "-" +
                        _vm._s(
                          _vm.params.countryName ||
                            _vm.$t("ocean-bi::sale-area::全球")
                        ) +
                        " "
                    ),
                  ]
                ),
                _c(
                  "span",
                  { staticStyle: { color: "#ffd74f", cursor: "pointer" } },
                  [
                    _c(
                      "span",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.toReCategory(0)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("system::common::select_all")))]
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.categoryLevel.level1.name,
                            expression: "categoryLevel.level1.name",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.toReCategory(1)
                          },
                        },
                      },
                      [_vm._v("/" + _vm._s(_vm.categoryLevel.level1.name))]
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.categoryLevel.level2.name,
                            expression: "categoryLevel.level2.name",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.toReCategory(2)
                          },
                        },
                      },
                      [_vm._v("/" + _vm._s(_vm.categoryLevel.level2.name))]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading.saleWorld,
                        expression: "loading.saleWorld",
                      },
                    ],
                    staticClass: "category-overview",
                    attrs: {
                      "element-loading-background": "rgba(34, 34, 36, 0.3)",
                    },
                  },
                  [
                    _vm.saleCategoryForWorld.length
                      ? _vm._l(_vm.saleCategoryForWorld, function (item) {
                          return _c(
                            "div",
                            {
                              key: item.city,
                              staticClass: "bar-item",
                              on: {
                                click: function ($event) {
                                  return _vm.toNextCategory(item)
                                },
                              },
                            },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: item.goodsOneType,
                                    placement: "top-start",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "bar-name" }, [
                                    _vm._v(
                                      _vm._s(item[_vm.categoryName + "Type"])
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "el-popover",
                                {
                                  staticClass: "progress",
                                  attrs: {
                                    placement: "right-start",
                                    width: "200",
                                    trigger: "hover",
                                    "append-to-body": false,
                                    "popper-class": "bar-popover",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "bar-popover-title" },
                                    [
                                      _vm._v(
                                        _vm._s(item[_vm.categoryName + "Type"])
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "bar-popover-content" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("ocean-bi::sale-area::销量")
                                          )
                                        ),
                                      ]),
                                      _c("span", [_vm._v(_vm._s(item.sale))]),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "bar-popover-content" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "ocean-bi::sale-area::成交额"
                                            )
                                          )
                                        ),
                                      ]),
                                      _c("span", [
                                        _vm._v(
                                          "$" +
                                            _vm._s(
                                              Number(
                                                item.grandTotalUsd
                                              ).toFixed(2)
                                            )
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "bar-popover-content" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "ocean-bi::sale-area::退款量"
                                            )
                                          )
                                        ),
                                      ]),
                                      _c("span", [
                                        _vm._v(_vm._s(item.refundSale)),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "bar-popover-content" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "ocean-bi::sale-area::退款金额"
                                            )
                                          )
                                        ),
                                      ]),
                                      _c("span", [
                                        _vm._v(
                                          "$" +
                                            _vm._s(
                                              Number(item.refundUsd).toFixed(2)
                                            )
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c("el-progress", {
                                    staticStyle: { cursor: "pointer" },
                                    attrs: {
                                      slot: "reference",
                                      "text-inside": true,
                                      "stroke-width": 18,
                                      percentage: item.per,
                                      color: "#68D287",
                                      format: function (val) {
                                        return item.sale
                                      },
                                    },
                                    slot: "reference",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        })
                      : _c("ZDefaultData", {
                          staticStyle: { background: "none" },
                          attrs: {
                            custom: {
                              height: "200px",
                              img: require("@/assets/images/emptyDefault/empty_dark.png"),
                            },
                          },
                        }),
                  ],
                  2
                ),
              ]),
              _c("el-col", { attrs: { span: 12 } }, [
                _c("div", { staticClass: "custom-card" }, [
                  _c("div", { staticClass: "header" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("ocean-bi::sale-area::品类销售趋势"))
                      ),
                    ]),
                    _c("span", { staticStyle: { opacity: "0.6" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.categoryLevel.level2.name ||
                              _vm.categoryLevel.level1.name ||
                              _vm.$t("ocean-bi::sale-area::全品类")
                          ) +
                          " "
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading.saleTrend,
                          expression: "loading.saleTrend",
                        },
                      ],
                      attrs: {
                        "element-loading-background": "rgba(40, 40, 42, 0.3)",
                      },
                    },
                    [
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.saleTrend.length,
                            expression: "saleTrend.length",
                          },
                        ],
                        ref: "categoryTrend",
                        staticClass: "category-trend",
                      }),
                      _c("ZDefaultData", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.saleTrend.length,
                            expression: "!saleTrend.length",
                          },
                        ],
                        staticStyle: { background: "none" },
                        attrs: {
                          custom: {
                            height: "230px",
                            img: require("@/assets/images/emptyDefault/empty_dark.png"),
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "div",
                  {
                    staticClass: "custom-card",
                    staticStyle: { height: "450px", "margin-top": "24px" },
                  },
                  [
                    _c("div", { staticClass: "header" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("ocean-bi::sale-area::SPU销售概况"))
                        ),
                      ]),
                      _c("span", { staticStyle: { opacity: "0.6" } }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.categoryLevel.level2.name ||
                                _vm.categoryLevel.level1.name ||
                                _vm.$t("ocean-bi::sale-area::全品类")
                            ) +
                            " "
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading.spuTrend,
                            expression: "loading.spuTrend",
                          },
                        ],
                        staticClass: "spu-table",
                        attrs: {
                          "element-loading-background": "rgba(40, 40, 42, 0.3)",
                        },
                      },
                      [
                        _c(
                          "el-table",
                          {
                            staticStyle: { "border-radius": "0px 0px 6px 6px" },
                            attrs: {
                              data: _vm.saleCategoryForSpu,
                              height: "400",
                              "highlight-current-row": false,
                            },
                            on: { handleScrollEnd: _vm.onTableEnd },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "spuId",
                                label: "SPU_ID",
                                width: "160",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "image",
                                label: _vm.$t("ocean-bi::sale-area::图片"),
                                width: "100",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _c("ZImg", {
                                        staticStyle: {
                                          width: "40px",
                                          height: "40px",
                                          "border-radius": "4px",
                                        },
                                        attrs: { src: row.spuIcon },
                                      }),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "price",
                                label: _vm.$t("ocean-bi::sale-area::售价"),
                                "min-width": "100",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(
                                        " $" +
                                          _vm._s(
                                            (Number(row.minPrice) || 0).toFixed(
                                              2
                                            )
                                          ) +
                                          "~$" +
                                          _vm._s(
                                            (Number(row.maxPrice) || 0).toFixed(
                                              2
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "sale",
                                label: _vm.$t("ocean-bi::sale-area::销量"),
                                "min-width": "160",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "saleRate",
                                label: _vm.$t("ocean-bi::sale-area::销量占比"),
                                "min-width": "120",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(row.saleRate) + "%"),
                                      ]),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "grandTotalUsd",
                                label: _vm.$t("ocean-bi::sale-area::销售额"),
                                "min-width": "160",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            Number(row.grandTotalUsd).toFixed(2)
                                          )
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "refundSale",
                                label: _vm.$t("ocean-bi::sale-area::退款量"),
                                width: "120",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "handleIcon",
        {
          attrs: { isAllScreen: _vm.isAllScreen },
          on: {
            allScreen: function ($event) {
              return _vm.toggleAllScreenFull(!_vm.isAllScreen)
            },
          },
        },
        [
          _c("template", { slot: "menu" }, [
            _c("li", { on: { click: _vm.getAllData } }, [
              _c("div", { staticClass: "icon" }, [
                _c("i", { staticClass: "iconfont iconRefresh" }),
              ]),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("dashboard-bi::default-board::refresh"))),
              ]),
            ]),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }